module.exports = __webpack_public_path__ + "img/_ecp_.19e87053.svg";